import React from 'react'
import { clsx } from 'clsx'

const Card = ({
  children,
  className = '',
  padding = true,
  ...props
}) => {
  return (
    <div
      className={clsx('animate-fade-in', className)}
      style={{
        background: 'var(--color-surface)',
        borderRadius: '16px',
        boxShadow: 'var(--shadow-card)',
        border: '1px solid var(--color-border-strong)',
        padding: padding ? '14px' : undefined,
      }}
      {...props}
    >
      {children}
    </div>
  )
}

const CardHeader = ({
  children,
  className = '',
  border = false,
  ...props
}) => {
  return (
    <div
      className={clsx('flex items-start justify-between gap-[10px] mb-[10px]', className)}
      style={border ? {
        paddingBottom: '10px',
        marginBottom: '10px',
        borderBottom: '1px solid var(--color-border)',
      } : undefined}
      {...props}
    >
      {children}
    </div>
  )
}

const CardBody = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <div className={className} {...props}>
      {children}
    </div>
  )
}

const CardFooter = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <div
      className={className}
      style={{
        paddingTop: '10px',
        marginTop: '10px',
        borderTop: '1px solid var(--color-border)',
      }}
      {...props}
    >
      {children}
    </div>
  )
}

Card.Header = CardHeader
Card.Body = CardBody
Card.Footer = CardFooter

export default Card
